export interface DataObject {
    name: string,
    id: string
}

export function createDataObject(element: any): DataObject {
    return{
        name: element.name ?? "",
        id: element.id ?? "",
    }
}

